import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {};

export function LanguageSwitch({}: Props) {
    const { t, i18n } = useTranslation();

    const languages = ['sv', 'en'];

    function switchLanguage() {
        i18n.changeLanguage(
            languages[(languages.indexOf(i18n.language) + 1) % languages.length]
        );
    }

    return (
        <div className="tooltip tooltip-bottom z-10" data-tip={t('switch-language')}>
            <button onClick={switchLanguage} className="btn btn-sm btn-square btn-primary">
                {i18n.language}
            </button>
        </div>
    );
}
